<template>
  <v-app>
    <Toolbar/>
    <v-main>
      <v-container fluid>
        <v-card>
          <v-container class="text-center pt-5 mt-5">
            <p class="display-4">404</p>
            <p class="headline">Página no encontrada</p>
          </v-container>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// eslint-disable-next-line import/extensions
// import Profile from '../../plugins/profile';
// eslint-disable-next-line import/extensions
import Toolbar from '../../components/Toolbar';

export default {
  name: 'Error404',
  components: {
    Toolbar,
  },
};

</script>
